import { Box, Title } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import i18n from 'modules/core/lib/i18n'

import { InputItem } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/InputItem'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  forms: Form[]
  employee?: Employee
}

const CustomFields = ({ forms, employee }: Props) => (
  <Box paddingTop="s24">
    <Title
      variant="400"
      illustration="user-edit"
      title={i18n.t('settings.custom_fields.title')}
      description={i18n.t('settings.custom_fields.description')}
    />
    <Box>
      {forms.map((form, key) => {
        const optional = employee && {
          employee,
        }

        return (
          <FormRow key={key}>
            <InputItem form={form} optional={optional} />
          </FormRow>
        )
      })}
    </Box>
  </Box>
)

export default observer(CustomFields)
